import { Stack, TextField } from '@mui/material';
import React, { ReactNode } from 'react';
import { NumericFormat } from 'react-number-format';

import FormFieldHelperAction, { IHelperAction } from './FormFieldHelperAction';

import InfoTooltip from '../InfoTooltip';

interface FormComponentProps {
  InputProps?: {
    endAdornment?: ReactNode;
    inputProps?: any;
  };
  allowNegative?: boolean;
  autoDecimalFormat?: boolean;
  disabled?: boolean;
  error: any;
  helperAction?: IHelperAction;
  infoTooltip?: string;
  label?: string;
  multiline?: boolean;
  max?: number;
  min?: number;
  name: string;
  onBlur?: any;
  onChange?: (value: number | null) => void;
  placeholder: string;
  prefix?: string;
  suffix?: string;
  readonly?: boolean;
  required?: boolean;
  thousandSeparator?: boolean;
  value?: any;
  helperText?: string;
  size?: 'small' | 'medium';
}

const FormComponent: React.FC<FormComponentProps> = (props) => {
  const {
    InputProps,
    allowNegative = false,
    autoDecimalFormat = false,
    helperAction,
    infoTooltip,
    max,
    min,
    onChange,
    readonly = false,
    thousandSeparator = true,
    ...numericProps
  } = props;

  return (
    <>
      <Stack direction="row" alignItems="center">
        <NumericFormat
          {...numericProps}
          fullWidth
          customInput={TextField}
          allowNegative={allowNegative}
          decimalScale={2}
          fixedDecimalScale={autoDecimalFormat ? true : false}
          thousandSeparator={thousandSeparator}
          isAllowed={(values) => {
            const { floatValue } = values;
            if (floatValue === undefined) {
              return true;
            }
            return (floatValue >= min || !min) && (floatValue <= max || !max);
          }}
          onValueChange={(values) => {
            const { floatValue } = values;
            onChange(floatValue ?? null);
            return floatValue;
          }}
          InputProps={{ readOnly: readonly, ...InputProps }}
          inputProps={{
            'data-testid': numericProps.name,
          }}
          size={numericProps.size || 'small'}
        />
        {infoTooltip && <InfoTooltip infoMessage={infoTooltip} />}
      </Stack>
      <FormFieldHelperAction action={helperAction} />
    </>
  );
};

export default FormComponent;
